<!--
  图片预览组件
-->
<template>
  <div>
    <div v-if="filesUrl.length > 0" style="margin-bottom: 10px">
      <div v-for="(file, index) in filesUrl" :key="index" class="file-list">
        <div class="file-item">
          <a style="text-decoration: underline !important;" target="_blank" :href="file.url" :download="file.fileName">{{file.fileName}}</a>
        </div>
      </div>
    </div>
    <div v-if="imgsUrl.length > 0">
      <viewer :images="imgsUrl" class="img-div">
        <div v-for="(img, index) in imgsUrl" :key="index" class="img-box">
          <img style="width:100px; height:100px;" :src="img.url" :alt="img.fileName">
        </div>
      </viewer>
    </div>
  </div>
</template>
<script>
import { baseURL } from '@/assets/js/config.js'
export default {
  name: 'ImgPreview',
  data () {
    return {
      baseURL: baseURL,
      imgRegx: /.+.(png|jpg|gif|jpeg|bmp|webp)/
    }
  },
  props: {
    ksid: Number, // 考试ID
    lsh: Number, // 流水号
    stid: Number,
    fileList: {
      type: Array, // 文件列表
      default: function () {
        return []
      }
    }
  },
  computed: {
    filesUrl () {
      const files = this.fileList.filter(file => { return file.stid === this.stid && !this.imgRegx.test(file.name.toLowerCase()) })
      return files.map(file => {
        const url = file.src || (baseURL + `/examineeAnswer/file/${this.ksid}/${this.lsh}/${file.name}`)
        this.$set(file, 'url', url)
        return file
      })
    },
    imgsUrl () {
      const images = this.fileList.filter(file => { return file.stid === this.stid && this.imgRegx.test(file.name.toLowerCase()) })
      return images.map(img => {
        const url = img.src || (baseURL + `/examineeAnswer/file/${this.ksid}/${this.lsh}/${img.name}`)
        this.$set(img, 'url', url)
        return img
      })
    }
  }
}
</script>
<style scoped>
  .file-list {
    display: flex;
    width: 90%;
    border-bottom: 1px dashed #ccc;
  }
  .file-item {
    display: inline-block;
    width: calc(100% - 100px);
    padding: 10px;
  }
  .img-div {
    display: flex;
    flex-wrap: wrap;
  }
  .img-box {
    width: 100px;
    height: 100px;
    line-height: 100px;
    padding: 2px;
    position: relative;
  }
</style>
